<comment>
ズームボタン
プロパティの3値でボタンのdisabledを制御
３種のボタンをクリック時対応するイベントをemit
拡大：zoomInClicked
縮小：zoomOutClicked
リセット：zoomResetClicked
</comment>

<template>
  <div class="zoom-btns">
    <button @click="zoomInClicked()" class="zoom-btns__in" :disabled="zoomMaxFlg"></button>
    <button @click="zoomResetClicked()" class="zoom-btns__reset" :disabled="zoomResetFlg"></button>
    <button @click="zoomOutClicked()" class="zoom-btns__out" :disabled="zoomMinFlg"></button>
  </div>
</template>

<script>
export default {
  name: 'zoomBtns',
  props: ['zoomMaxFlg','zoomMinFlg','zoomResetFlg'],
  methods: {
    zoomInClicked: function(){
      this.$emit('zoomInClicked');
    },
    zoomOutClicked: function(){
      this.$emit('zoomOutClicked');
    },
    zoomResetClicked: function(){
      this.$emit('zoomResetClicked');
    },
  },
}
</script>

<style lang="scss" scoped>
.zoom-btns{
  position: absolute;
  width: 63px;
  //height: 228px;
  height: 191px;
  left: 9px;
  top: 50%;
  margin-top: -104px;
  background: rgba(123,123,123,0.5);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 7px 0;

  &__in,
  &__reset,
  &__out{
    width: 35px;
    height: 35px;
    display: block;
    border: 0;
    appearance: none;
    cursor: pointer;
    background: no-repeat 50% 50%;
    background-size: 35px 35px;
    padding: 10px;
    box-sizing: content-box;
    &:disabled{
      opacity: 0.5;
      cursor: default;
    }
  }
  &__in{
    background-image: url(../assets/image/zoom_icon_p.png);
  }
  &__reset{
    background-image: url(../assets/image/zoom_icon_r.png);
  }
  &__out{
    background-image: url(../assets/image/zoom_icon_m.png);
  }
}
</style>